import { render, staticRenderFns } from "./Canteen.vue?vue&type=template&id=303c1554&"
import script from "./Canteen.vue?vue&type=script&lang=js&"
export * from "./Canteen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports